module.exports = __webpack_public_path__ + "media/images/icons/material/star-cd7402bbe48dfdddd21867424c663788.svg";